module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="comment-item-wrapper">\n    <div class="comment-content">\n        <div class="comment-date"></div>\n        <div class="comment-body">\n            <div class="comment-author"></div>\n            <div class="comment-message"></div>\n        </div>\n    </div>\n    <div class="comment-color-indicator"></div>\n    <div class="comment-spacer"></div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/comments/CommentItemView.tpl
// module id = 2972
// module chunks = 0